import instance from '../index';

const RES_NOTIFICATION = 'notifications?page={page}&pageSize={pageSize}';

export const NotificationApi = {
  getData({ page, size }) {
    return instance.get(`${RES_NOTIFICATION.replace('{page}', page).replace('{pageSize}', size)}`);
  }
};
